"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeDisplayName = exports.clampNumber = exports.getCaptchaElement = exports.toPrettyPhoneNum = exports.rawPhoneNumber = exports.firebasePhoneFormat = void 0;
exports.firebasePhoneFormat = (phoneNumber) => {
    if (phoneNumber === "") {
        return "";
    }
    return `+1${exports.rawPhoneNumber(phoneNumber)}`;
};
exports.rawPhoneNumber = (prettyPhoneNumber) => {
    return prettyPhoneNumber.replace("(", "").replace(")", "").split(" ").join("");
};
exports.toPrettyPhoneNum = (fullPhoneNumber) => {
    if (fullPhoneNumber === "") {
        return "";
    }
    const n = fullPhoneNumber.slice(2);
    return [`(${n.slice(0, 3)})`, n.slice(3, 6), n.slice(6, 10)].join(" ");
};
function getCaptchaElement(findId) {
    let element = document.getElementById(findId);
    if (!element) {
        element = document.createElement("div");
        element.id = findId;
        document.body.appendChild(element);
    }
    return element;
}
exports.getCaptchaElement = getCaptchaElement;
exports.clampNumber = (num, a, b) => Math.max(Math.min(num, Math.max(a, b)), Math.min(a, b));
exports.capitalizeDisplayName = (displayName) => {
    // only capitalizes first letter and leaves the rest so names like "McKelvey" don't turn into "Mckelvey" :puke:
    return displayName
        .split(" ")
        .map((word) => word.replace(word[0], word[0].toUpperCase()))
        .join(" ");
};
//# sourceMappingURL=utils.js.map